import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import { useLocation } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";
import { SubcriptionApis } from '../Api/SubcriptionService';

const UnsubcribePage = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const sessionId = queryParams.get("session_id");
    const invoiceNumber = queryParams.get("invNum");
    const pageType = queryParams.get("type");
    const invoiceToken = queryParams.get("invoiceId");
    const companyToken = queryParams.get("companyId");

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState(null);


    useEffect(() => {
        const fetchStatus = async () => {
            if (!sessionId) {
                setError(true);
                setLoading(false);
                return;
            }

            try {
                const res = await SubcriptionApis.getSessionStatus(sessionId);
                const status = res.data.status;
                setPaymentStatus(status);
                setLoading(false);
                if (status === "paid") {
                    try {
                        if (pageType === "Enterprise" && invoiceNumber) {
                            const today = new Date().toISOString().split("T")[0];
                            const payload = {
                                invoicePaidDate: today,
                                status: "Paid",
                            };
                            // const [dinvoiceNumber] = await Promise.all([
                            //     SubcriptionApis.decodeTokenByValue(invoiceNumber),
                            // ]);
                            await SubcriptionApis.updateGenerateInvoice(payload, invoiceNumber);
                        }
                        if (pageType === "Invoice" && invoiceToken && companyToken) {
                            const [decodedInvoice, decodedCompany] = await Promise.all([
                                SubcriptionApis.decodeTokenByValue(invoiceToken),
                                SubcriptionApis.decodeTokenByValue(companyToken)
                            ]);
                            await SubcriptionApis.updateInvoiceAfterPayment(
                                decodedInvoice.data.data,
                                decodedCompany.data.data,
                                res.data.amount_total,
                                {}
                            );
                        }
                    } catch (internalError) {
                        const message = pageType === "Invoice" ? "We encountered a technical issue while updating the invoice status. Please contact your administrator or support team" :
                            "We encountered a technical issue while updating your subscription details.Please contact your administrator or support team"
                        if (message) {
                            toast.error(message);
                        }
                    }
                }
            } catch (err) {
                setError(true);
                setLoading(false);
            }
        };

        const timer = setTimeout(() => {
            fetchStatus();
        }, 1000);

        return () => clearTimeout(timer);
    }, [sessionId, invoiceNumber]);

    return (
        <div className="min-h-screen section-padding flex items-center justify-center section-dark">
            <div className="container max-w-2xl mx-auto text-center">
                {loading && (
                    <div className="py-20">
                        <div className="w-10 h-10 border-4 border-gray-600 border-t-blue-500 rounded-full animate-spin mx-auto"></div>
                        <p className="mt-4 text-gray-300">Checking payment status...</p>
                    </div>
                )}

                {!loading && error && (
                    <div className="py-20">
                        <div className="w-20 h-20 rounded-full bg-red-400/10 flex items-center justify-center mx-auto mb-8">
                            <XCircle className="h-10 w-10 text-red-400" />
                        </div>
                        <h1 className="display-md text-white mb-6">Failed to fetch payment status</h1>
                        <p className="body-lg mb-8">Please try again later or contact support.</p>
                    </div>
                )}

                {!loading && !error && paymentStatus === "paid" && (
                    <div className="py-20">
                        <div className="w-20 h-20 rounded-full bg-green-400/10 flex items-center justify-center mx-auto mb-8">
                            <CheckCircle className="h-10 w-10 text-green-400" />
                        </div>
                        <h1 className="display-md text-white mb-6">Payment Successful!</h1>
                        <p className="body-lg mb-8">
                            Your payment has been completed successfully.
                        </p>
                    </div>
                )}

                {!loading && !error && paymentStatus !== "paid" && paymentStatus !== null && (
                    <div className="py-20">
                        <div className="w-20 h-20 rounded-full bg-red-400/10 flex items-center justify-center mx-auto mb-8">
                            <XCircle className="h-10 w-10 text-red-400" />
                        </div>
                        <h1 className="display-md text-white mb-6">Payment Failed</h1>
                        <p className="body-lg mb-8">
                            Your payment was not successful. Please try again.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UnsubcribePage;
